import type { ParsedQs } from 'qs';

export const isReferrerGoogle = (referrer: string) => {
  try {
    const url = new URL(referrer);
    const validHosts = ['google.com', 'www.google.com'];
    return validHosts.includes(url.hostname);
  } catch {
    return false;
  }
};
export const plaCheck = (
  referrer: string | undefined,
  campParam: ParsedQs[string],
  emailPLAParam: ParsedQs[string],
  ignoreReferrer = false,
) => {
  const camp = typeof campParam === 'string' ? campParam.toUpperCase() : undefined;
  return (
    (!ignoreReferrer && typeof referrer === 'string' && isReferrerGoogle(referrer)) ||
    camp?.includes('CSE') ||
    camp?.includes('SEM') ||
    camp?.includes('SNS') ||
    camp?.includes('DSP') ||
    emailPLAParam === 'true'
  );
};
